import React, { useState } from "react";
import { CreateCorrespondentInterface } from "../../create/interface/CreateCorrespondentInterface";
import { useDownloadAccountFile, useReadAccountTierInfo } from "../hooks";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import useFileUpload from "../../../../../components/common/fileUpload/fileUploadWithText/hooks/useFileUpload";
import { UploadedFile } from "../interface";
import FileUploadWithText from "../../../../../components/common/fileUpload/fileUploadWithText/FileUploadWithText";
import useCreateAccountPtaTierFile from "../hooks/useCreateAccountPtaTierFile";
import useDeleteAccountPtaTierFile from "../hooks/useDeleteAccountPtaTierFile";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";
import { useUser } from "../../../../../util/userContext/UserContext";
import { useModal } from "../../../../../hooks";
import PTASearch from "../mod/PTASearch";

type Props = {
    searchData: CreateCorrespondentInterface;
    name: string | null;
};

/**
 * PTA 티어정보보 탭
 * @param props
 * @returns
 */
export const PTATab = ({ searchData, name }: Props) => {
    const { handleModal } = useModal();
    const { data } = useReadAccountTierInfo({
        searchData: {
            ...searchData,
        },
    });

    const [file, setFile] = useState<(File & { fileId?: number }) | null>(null);
    const { user } = useUser()

    const { mutate: createFileMutate } = useCreateAccountPtaTierFile();
    const { mutate: deleteFileMutate } = useDeleteAccountPtaTierFile();
    const { mutate: downloadFileMutate } = useDownloadAccountFile();

    const handleFilesChange = (files: File[]) => {
        if (setFile) {
            if (files[0]) {
                setFile(files[0]);
            } else {
                setFile(null);
            }
        }
    };

    const {
        fileRef,
        files,
        handleButtonClick,
        handleChange,
        deleteFile,
        deleteUpdatedFile,
    } = useFileUpload({
        uploadedFiles: data?.basicTierInfo?.accountFileVO
            ? [data?.basicTierInfo?.accountFileVO as UploadedFile]
            : [],
        isMulti: false,
    });

    const saveFile = () => {
        if (file) {
            if (file.fileId) {
                return;
            }
            const form = new FormData();
            form.append("accountId", searchData?.accountId);
            form.append("file", file);
            createFileMutate(form);
        } else {
            if (data?.basicTierInfo?.accountFileVO) {
                deleteFileMutate(data?.basicTierInfo?.accountFileVO);
            }
        }
    };

    const handleAllRead = () => {
        handleModal({
            isOpen: true,
            noHeader: true,
            className: 'my_modal xl',
            modalSize: 'xl',
            contents: <PTASearch name={name} />,
            type: ''
        })
    }

    return (
        <div className="content_wrap">
            <h5 className="subheading mt-0">PTA 정보</h5>
            <div className="table_scroll mb-20px">
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>CLA 문서</th>
                            <td style={{ width: "33.34%" }} className="p-4px">
                                <div className="d-flex justify-content-between">
                                    {/*<AuthorityChecker authorityNames={['clientWriteYn']}>*/}
                                    <FileUploadWithText
                                        mode={user?.authority.clientWriteYn === "Y"
                                            ? "RU"
                                            : "R"}
                                        fileRef={fileRef}
                                        files={files}
                                        onFilesChange={handleFilesChange}
                                        uploadedFiles={
                                            data?.basicTierInfo?.accountFileVO
                                                ? [data?.basicTierInfo?.accountFileVO as UploadedFile]
                                                : []
                                        }
                                        downloadMutate={({ data }) => {
                                            downloadFileMutate(data);
                                        }}
                                        handleChange={handleChange}
                                        handleButtonClick={handleButtonClick}
                                        deleteUpdatedFile={deleteUpdatedFile}
                                        deleteFile={deleteFile}
                                    />
                                    <AuthorityChecker authorityNames={['clientWriteYn']}>
                                        <button
                                            className="btn btn-info btn_search ms-5px"
                                            onClick={() => saveFile()}
                                        >
                                            저장
                                        </button>
                                    </AuthorityChecker>
                                </div>
                            </td>
                            <th style={{ width: "16.66%" }}>CLA Number</th>
                            <td>{data?.basicTierInfo?.claNumber ?? "-"}</td>
                        </tr>
                        <tr>
                            <th>Parent CompanyID</th>
                            <td>{data?.basicTierInfo?.parentCompanyId ?? "-"}</td>
                            {/* <th>연락처</th>
                        <td>-</td> */}
                            <th></th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>CompanyID</th>
                            <td>{data?.basicTierInfo?.companyId ?? "-"}</td>
                            <th>Company Legal Name</th>
                            <td>{data?.basicTierInfo?.companyLegalName ?? "-"}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="table_top">
                <h6 className="table_stats">
                    PTA 이력 (<span>{data?.tierList?.length ?? 0}</span>건)
                </h6>
                <div className="table_toolbar"><button className="btn btn-info btn_search ms-5px" style={{ width: '100px' }} onClick={handleAllRead}>전체보기</button></div>
            </div>

            <div className="table_scroll">
                <table className="table table-bordered my_table">
                    <thead>
                        <tr>
                            <th style={{ width: "5%" }}>No</th>
                            <th style={{ width: "25%" }}>기준</th>
                            <th style={{ width: "40%" }}>Pricing Group</th>
                            <th style={{ width: "15%" }}>Pricing Tier</th>
                            <th style={{ width: "15%" }}>ERP코드</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.tierList?.length === 0 ? (
                            <EmptyTableRow colSpan={5} />
                        ) : (
                            data?.tierList?.map((item, index) => (
                                <tr key={index}>
                                    <td className="text-center">{index + 1}</td>
                                    <td className="text-center">{item?.standard ?? "-"}</td>
                                    <td className="text-center">{item?.pricingGroup ?? "-"}</td>
                                    <td className="text-center">{item?.priceTier ?? "-"}</td>
                                    <td className="text-center">{item?.erpCode ?? "-"}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* <div className="pagination-container">
        <ul>
          <li className="pg_nav">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
              alt="First Page"
              className=""
            />
          </li>
          <li className="pg_nav">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
              alt="Previous Page"
              className=""
            />
          </li>
          <li className="active">1</li>
          <li className="">2</li>
          <li className="">3</li>
          <li className="">4</li>
          <li className="">5</li>
          <li className="pg_nav">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
              alt="Next Page"
              className=""
            />
          </li>
          <li className="pg_nav">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
              alt="Last Page"
              className=""
            />
          </li>
        </ul>
      </div> */}
        </div>
    );
};
